// This is a container component. It is almost identical to ContentPanel.
// I've kept it separate in case of a need to pass different
// props or classNames

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';
import s from './ActionsPanel.css';


export default class ActionsPanel extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
  }

  componentWillMount() {
    this.setState({
      children: this.props.children,
    });
  }

  render() {
    return (
      <div className={cx(s.component, this.props.className)}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ActionsPanel/ActionsPanel.js